var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6873 15.375C13.998 15.3749 14.25 15.6266 14.25 15.9373C14.25 16.2479 13.9983 16.4999 13.6877 16.5L3.93766 16.5028C3.627 16.5029 3.375 16.2511 3.375 15.9404C3.375 15.6298 3.62668 15.3779 3.93734 15.3778L13.6873 15.375ZM8.73617 1.5088L8.8125 1.50366C9.09727 1.50366 9.33262 1.71528 9.36987 1.98983L9.375 2.06616L9.37425 12.3299L12.1656 9.53966C12.3653 9.33998 12.6778 9.32186 12.898 9.48528L12.9611 9.53975C13.1608 9.73947 13.1789 10.052 13.0155 10.2722L12.961 10.3352L9.21279 14.0827C9.01318 14.2823 8.70089 14.3005 8.4807 14.1373L8.41761 14.0829L4.66502 10.3355C4.4452 10.116 4.44496 9.7598 4.66448 9.53998C4.86404 9.34014 5.17653 9.32177 5.39685 9.48501L5.45998 9.53943L8.24925 12.3247L8.25 2.06616C8.25 1.78139 8.46162 1.54604 8.73617 1.5088L8.8125 1.50366L8.73617 1.5088Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDownload);
export default __webpack_public_path__ + "static/media/icon-arrow-download.5805bf7fdb1059f9c8040ffcefaea647.svg";
export { ForwardRef as ReactComponent };